module.exports = __webpack_public_path__ + "img/left_md_1.44b8e15e.jpg";